import { createNode } from '@glueapp/graph-types';

export const Modulo = createNode({
    id: 'Modulo',
    name: 'Modulo',
    description: 'A Node for getting the remained of a division',
    aiDescription:
        'Computes the remainder of dividing Dividend by Divisor. Connect values to "Dividend" and "Divisor" input ports; the "Remainder" output port provides the result. Division by zero returns 0.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Dividend: { kind: 'number' },
        Divisor: { kind: 'number' },
    },
    outPorts: {
        Remainder: { kind: 'number' },
    },
    execute: function (input) {
        const divisorValue = input.inPorts.Divisor;
        if (divisorValue !== 0) {
            return { output: { Remainder: input.inPorts.Dividend % divisorValue } };
        } else {
            return { output: { Remainder: 0 } };
        }
    },
});
